module.exports = __webpack_public_path__ + "img/img_idcard@3x.3d8c94cc.png";